import I18n from 'i18n-js';
import React, { useState } from 'react';
import SlideShowCard from '@/components/shared/NewLessonOverview/Cards/SlideShowCard';
import { SlideGroup } from '@/types/api/LessonOverview';
import SlideGroupCard from '@/components/shared/NewLessonOverview/Cards/SlideGroupCard';
import Grid from '@/components/shared/NewLessonOverview/Cards/Grid';
import ReadingCard from '../Cards/ReadingCard';
import useLessonOverviewContext from '../useLessonOverviewContext';
import ShowSlideshowCheckbox from '../ShowSlideshowCheckbox';
import LessonSubheader from '../LessonSubheader';
import { shouldRenderSlideShow } from './utils';

type LessonOptionsProps = {
  subheaderNumber?: number;
};

const LessonOptions = ({ subheaderNumber }: LessonOptionsProps) => {
  const firstTCISlideShow = useLessonOverviewContext(state => state.firstTCISlideShow());
  const newTCISlideShows = useLessonOverviewContext(state => state.newTCISlideShows());
  const oldTCISlideShows = useLessonOverviewContext(state => state.oldTCISlideShows());
  const teacherSlideShows = useLessonOverviewContext(state => state.teacherSlideShows());
  const slideGroups = useLessonOverviewContext(state => state.lessonOptionsSlideGroups());
  const sections = useLessonOverviewContext(state => state.sections);
  const isStaffer = useLessonOverviewContext(state => state.isStaffer);

  const slideShowsToRender = [...newTCISlideShows, ...oldTCISlideShows];
  const readingCardSections = sections.filter(s => s.kind === 'default' && s.investigation === false);

  const [showTeacherSlideShows, setShowTeacherSlideShows] = useState(false);

  return (
    <LessonSubheader subheaderNumber={subheaderNumber} title={I18n.t('choose_a_lesson')}>
      {isStaffer && (
        <ShowSlideshowCheckbox
          isChecked={showTeacherSlideShows}
          setIsChecked={setShowTeacherSlideShows}
        />
      )}

      <Grid>
        {firstTCISlideShow && (
          <div className="tw-row-span-2">
            <SlideShowCard slideShow={firstTCISlideShow} />
          </div>
        )}

        {slideShowsToRender.map((slideShow) => {
          if (!shouldRenderSlideShow(slideShow)) return null;

          return (
            <div key={slideShow.id} className="tw-row-span-2">
              <SlideShowCard slideShow={slideShow} />
            </div>
          );
        })}

        {readingCardSections.length > 0 && (
          <ReadingCard
            sections={readingCardSections}
          />
        )}

        {slideGroups?.map(slideGroup => (
          <SlideGroupCard key={slideGroup.id} slideGroup={slideGroup} />
        ))}
      </Grid>

      {isStaffer && showTeacherSlideShows && teacherSlideShows?.length > 0 && (
        <Grid className="tw-mt-4">
          {teacherSlideShows.map((slideShow) => {
            if (!shouldRenderSlideShow(slideShow)) return null;

            return (
              <SlideShowCard
                key={slideShow.id}
                isTeacherSlideShow
                slideShow={slideShow}
              />
            );
          })}
        </Grid>
      )}

      {!isStaffer && teacherSlideShows?.length > 0 && (
        <Grid className="tw-mt-4">
          {teacherSlideShows.map(slideShow => (
            <SlideShowCard
              key={slideShow.id}
              isTeacherSlideShow
              slideShow={slideShow}
            />
          ))}
        </Grid>
      )}
    </LessonSubheader>
  );
};

export default LessonOptions;
